import { Box, Card, Typography } from "@mui/material";
import React from "react";
export function GreenRisotto() {
  return (
    <Card sx={{ backgroundColor: "#bbbbbb" }}>
      <Typography variant="h1">Green Risotto</Typography>

      <Typography>
        <Typography variant="h3">Ingredients</Typography>5 cups stock/broth
        <br></br>1 10-ounce bag spinach, tough stems removed<br></br>1 cup fresh
        basil leaves<br></br>2 tablespoons extra-virgin olive oil<br></br>1 cup
        chopped shallots or onion<br></br>4 cloves garlic, minced<br></br>1 ½
        cups arborio, carnaroli or other risotto rice<br></br>¼ teaspoon salt
        <br></br>1 cup dry white wine(optional)<br></br>1 cup finely shredded
        Parmigiano-Reggiano cheese, divided<br></br>
        Freshly ground pepper to taste<br></br>
        1/3 cup toasted pine nuts (see Tip)<br></br>
      </Typography>

      <Typography>
        Bring broth to a simmer in a medium saucepan over medium-high heat.
        <br></br>
        Reduce the heat so the broth remains steaming, but is not simmering.
        <br></br>
        <br></br>
        Rinse spinach thoroughly with cold water and place in a large
        microwave-safe bowl.<br></br>
        Cover with plastic wrap and punch several holes in it.<br></br>
        Microwave on High until wilted, 2 to 3 minutes.<br></br>
        Let cool, then squeeze out excess moisture.<br></br>
        Transfer to a food processor or blender, add basil and puree until
        smooth; set aside.<br></br>
        <br></br>
        Heat oil in a Dutch oven over medium-low heat.<br></br>
        Add shallots (or onion) and cook, stirring occasionally, until softened,
        about 2 minutes.<br></br>
        Add garlic and cook, stirring, until fragrant, about 30 seconds.
        <br></br>
        Add rice and salt and stir to coat.<br></br>
        <br></br>
        Stir 1/2 cup of the hot broth and a generous splash of wine into the
        rice.<br></br>
        Cook, stirring frequently, until the liquid has been absorbed.<br></br>
        Continue to cook on medium-low, adding broth in 1/2-cup increments
        followed by a splash of wine, and stirring frequently after each
        addition, until most of the liquid is absorbed.<br></br>
        The risotto is done when you've used all the broth and wine and the rice
        is creamy and just tender, 25 to 35 minutes total.<br></br>
        Stir in the reserved spinach-basil puree.<br></br>
        <br></br>
        Remove from the heat; stir in 3/4 cup cheese and pepper.<br></br>
        Serve sprinkled with pine nuts and the remaining 1/4 cup cheese.
        <br></br>
      </Typography>
    </Card>
  );
}
